import { render, staticRenderFns } from "./ItemIndex.vue?vue&type=template&id=efbbb040&scoped=true&"
import script from "./ItemIndex.vue?vue&type=script&lang=js&"
export * from "./ItemIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbbb040",
  null
  
)

export default component.exports